import '../../../../Assets/app.base'
import './Guestlist.scss'

// Components
import '../../../../Components/Carousel'
import '../../../../Components/Countdown'
import '../../../../Components/ViewTracker'
import '../../../../Components/ParentingAssignmentDownload';

// Helper
import inlineForm from '../../../../Assets/scripts/forms/inlineForm'

function bind (element) {
  element.find('#form-field-email-info-trigger').click(e => {
    e.preventDefault()
    element.find('#form-field-email-info-target').toggle()
  })
  element.find('#form-field-confirmation-info-trigger').click(e => {
    e.preventDefault()
    element.find('#form-field-confirmation-info-target').toggle()
  })

  const target = element.find('#additional-guests-container')
  element.find('#add-additional-guest-btn').click(e => {
    e.preventDefault()
    addGuestForm(element, target, Date.now())
  })
  bindAdditionalGuestDeleteHandler(element, target)
}

function addGuestForm (form, target, id) {
  const config = window.eventGuestlistFormConfig.additionalGuest
  const elementId = `additional-guest-${id}`

  target.append(`
    <div id="${elementId}" class="mb-3">
      <h6>
        ${config.title}
        <span class="count"></span>
      </h6>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <input class="form-control" placeholder="${config.inputFirstnameLabel}" type="text" value="" />
          </div>
          <div class="form-group">
            <input class="form-control" placeholder="${config.inputLastnameLabel}" type="text" value="" />
          </div>
        </div>
        <div class="col-auto">
          <button type="button" class="remove-additional-guest btn btn-danger btn-raised btn-sm btn-icon" data-id="${elementId}">
            <span class="material-icons">delete</span>
          </button>
        </div>
      </div>
    </div>
  `)

  bindAdditionalGuestDeleteHandler(form, target)
  recalculateInputIndex(target)
}

function recalculateInputIndex(target) {
  target.find('div[id^=additional-guest-]').each(function(i) {
    const field1 = $($(this).find('input').get(0))
    const field2 = $($(this).find('input').get(1))
    
    field1.attr('name', `AdditionalGuests[${i}].Firstname`)
    field2.attr('name', `AdditionalGuests[${i}].Lastname`)
    $(this).find('.count').text(i + 1)
  })
}

function bindAdditionalGuestDeleteHandler (form, target) {
  const buttons = target.find('button.remove-additional-guest')
  buttons.off()
  buttons.click(function (e) {
    e.preventDefault()

    const id = $(this).data('id')
    target.find(`#${id}`).remove()

    bindAdditionalGuestDeleteHandler(form, target)
    recalculateInputIndex(target)
  })

  const count = target.children().length
  form.find('#add-additional-guest-btn').attr('disabled', count >= 10)
}

function init () {
  const form = $('#form-target')

  if (form) { inlineForm(form, bind) }
}

$(function () {
  init()
})